import React from "react";

import { MonitorStatusContextProvider, type MonitorStatusContextValue } from "./_monitor-status-context";

export const MonitorStatusProvider: React.FC<React.PropsWithChildren<MonitorStatusContextValue>> = ({
	timeRange,
	children,
}) => (
	<MonitorStatusContextProvider value={React.useMemo(() => ({ timeRange }), [timeRange])}>
		{children}
	</MonitorStatusContextProvider>
);
